import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createArchiveReleaseCommand } from '../../../api/commands/factory/createReleaseCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ArchiveRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ArchiveRelease';

    public constructor(public id: string, public shouldSendCommand: boolean = true) {
        super(ArchiveRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ArchiveRelease): Promise<boolean> => {
    if (!action.shouldSendCommand) {
        return true;
    }

    const release = state.releases.find((x) => x.id === action.id);
    return await useSendCommandAsync(action, {
        createCommand: async () => await createArchiveReleaseCommand(state.id, release.id, release.name),
    });
};

const reducer = (state: StorymapState, action: ArchiveRelease): void => {
    const release = state.releases.find((x) => x.id === action.id);

    release.isPinned = false;
    release.isArchived = true;
    release.archivedAt = new Date().toString();
    release.archivedBy = initAppData.currentUser.currentUserFullName;
};

//@ts-ignore
registerMiddleware(ArchiveRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ArchiveRelease.ACTION_TYPE, reducer);
